// `crypto.getRandomValues` isn't accessible inside of our testing environment,
// so we create a fake UUID here. It's only meant to be used during tests.
function testUUID() {
  const characters = "abcdef1234567890"

  const random = n =>
    [...Array(n)]
      .map(() => characters[Math.floor(Math.random() * characters.length)])
      .join("")

  return `${random(8)}-${random(4)}-${random(4)}-${random(4)}-${random(12)}`
}

export function uuid() {
  if (process.env.NODE_ENV === "test") return testUUID()

  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16)
  )
}
